// extracted by mini-css-extract-plugin
export default {"cls1":"AppearanceForm-ThemeDescription_cls1__pmyFu","cls2":"AppearanceForm-ThemeDescription_cls2__bH+S9 AppearanceForm-ThemeDescription_cls1__pmyFu"};